/**
 * Projects tab module
 * Handles project filtering by type
 */

/**
 * Regex pattern for detecting hydropower-related content
 */
export const HYDRO_REGEX = /h\s*y\s*d\s*r\s*o/i;

/**
 * Checks if text contains hydropower-related keywords
 * @param {string} text - The text to check
 * @returns {boolean} True if contains hydro keywords
 */
export function isHydropowerProject(text) {
  return HYDRO_REGEX.test(text);
}

/**
 * Highlights projects based on type (hydropower vs non-hydropower) using fuzzy search
 * Projects remain visible but matching ones get highlighted with a ring
 * @param {string} type - Either 'hydropower' or 'non-hydropower'
 * @param {Document} doc - The document object
 * @returns {Object} Stats about highlighted projects
 */
export function showProjectTab(type, doc = document) {
  const btnHydro = doc.getElementById('btnHydro');
  const btnNon = doc.getElementById('btnNonHydro');
  const hydroTab = doc.getElementById('hydropower-tab');
  const nonHydroTab = doc.getElementById('non-hydropower-tab');

  if (!btnHydro || !btnNon || !hydroTab || !nonHydroTab) {
    return { highlighted: 0, total: 0, found: false };
  }

  // Reset buttons
  [btnHydro, btnNon].forEach((b) => {
    b.classList.remove('bg-primary', 'text-white');
    b.classList.add('bg-gray-200', 'text-gray-700');
  });

  // Remove previous highlights
  doc.querySelectorAll('.project-highlight').forEach((el) => {
    el.classList.remove('ring-2', 'ring-primary', 'project-highlight');
  });

  // Get all cards
  const allCards = doc.querySelectorAll(
    '#hydropower-tab article.card, #non-hydropower-tab article.card'
  );

  let highlightedCount = 0;

  if (type === 'hydropower') {
    btnHydro.classList.add('bg-primary', 'text-white');
    btnHydro.classList.remove('bg-gray-200', 'text-gray-700');
    allCards.forEach((card) => {
      const text = (card.textContent || '').toLowerCase();
      if (isHydropowerProject(text)) {
        card.classList.add('ring-2', 'ring-primary', 'project-highlight');
        highlightedCount++;
      }
    });
  } else {
    btnNon.classList.add('bg-primary', 'text-white');
    btnNon.classList.remove('bg-gray-200', 'text-gray-700');
    allCards.forEach((card) => {
      const text = (card.textContent || '').toLowerCase();
      if (!isHydropowerProject(text)) {
        card.classList.add('ring-2', 'ring-primary', 'project-highlight');
        highlightedCount++;
      }
    });
  }

  return {
    highlighted: highlightedCount,
    total: allCards.length,
    found: true,
  };
}

/**
 * Resets project highlights
 * @param {Document} doc - The document object
 */
export function resetProjectHighlights(doc = document) {
  doc.querySelectorAll('.project-highlight').forEach((el) => {
    el.classList.remove('ring-2', 'ring-primary', 'project-highlight');
  });
}
